import React from 'react';
import { ArrowRightIcon, CalendarIcon } from 'lucide-react';
export function BlogSection() {
  const articles = [{
    title: 'Kosten website laten maken',
    description: 'Wat kost een professionele website in 2026? Wij zetten de prijzen op een rij en leggen uit waar je op moet letten.',
    date: '15 feb 2026',
    slug: '#/kosten-website-laten-maken',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&h=400&fit=crop'
  }, {
    title: 'Website laten maken checklist',
    description: 'Alles wat je moet weten voordat je een website laat maken. Van domeinnaam tot content: deze checklist helpt je op weg.',
    date: '8 feb 2026',
    slug: '#/website-laten-maken-checklist',
    image: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?w=600&h=400&fit=crop'
  }, {
    title: 'WordPress vs Wix',
    description: 'Welk platform past het beste bij jouw bedrijf? We vergelijken WordPress en Wix op prijs, flexibiliteit en SEO.',
    date: '1 feb 2026',
    slug: '#/wordpress-vs-wix',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop'
  }];
  return <section id="kennisbank" className="py-24 lg:py-28 bg-surface-muted" data-id="element-264">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-265">
        <div className="text-center mb-12 lg:mb-16" data-id="element-266">
          {/* Norden portrait as section mascot */}
          <div className="w-16 h-16 rounded-full bg-accent-light border-2 border-accent/20 flex items-center justify-center mx-auto mb-5 overflow-hidden" data-id="element-267">
            <img src="https://cdn.magicpatterns.com/uploads/iiZ1GezbBxoz115PhFt8o5/Norden_portret_formulier_300dpi.png" alt="Norden mascotte" className="w-12 h-12 object-cover object-top" data-id="element-268" />
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-269">
            Laatste kennisbank artikelen
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-270">
            Tips en inzichten over webdesign, SEO en online groeien als
            ondernemer in Alkmaar.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-271">
          {articles.map(article => <a key={article.title} href={article.slug} className="group bg-white rounded-card overflow-hidden shadow-card hover:shadow-medium transition-all duration-300" data-id="element-272">
              {/* Image */}
              <div className="aspect-[16/10] overflow-hidden" data-id="element-273">
                <img src={article.image} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-274" />
              </div>

              {/* Content */}
              <div className="p-6" data-id="element-275">
                <div className="flex items-center gap-2 text-xs text-slate-400 mb-3" data-id="element-276">
                  <CalendarIcon className="w-3.5 h-3.5" data-id="element-277" />
                  {article.date}
                </div>
                <h3 className="text-lg font-bold text-navy-900 mb-2 group-hover:text-accent transition-colors" data-id="element-278">
                  {article.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed mb-4" data-id="element-279">
                  {article.description}
                </p>
                <span className="inline-flex items-center gap-1.5 text-accent font-semibold text-sm group-hover:gap-2.5 transition-all" data-id="element-280">
                  Lees meer
                  <ArrowRightIcon className="w-4 h-4" data-id="element-281" />
                </span>
              </div>
            </a>)}
        </div>

        <div className="mt-12 text-center" data-id="element-282">
          <a href="#/kennisbank" className="inline-flex items-center gap-2 text-accent hover:text-accent-hover font-semibold transition-colors group" data-id="element-283">
            Bekijk alle artikelen
            <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" data-id="element-284" />
          </a>
        </div>
      </div>
    </section>;
}